import { newE2EPage } from '@stencil/core/testing';

describe('chapel-video', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<chapel-video></chapel-video>');

    const element = await page.find('chapel-video');
    expect(element).toHaveClass('hydrated');
  });
});
